import _this from "../../main";
import router from '../../router'
import moment from 'moment'



export default {
  install(Vue) {
    //================ 用户校验相关
    //获取URL参数
   Vue.prototype.getQueryStringP = function (name) {
    // 检查是否是hash模式，并且参数是否在hash中
    const hashIndex = window.location.href.indexOf('#');
    if (hashIndex !== -1) {
      // 获取hash部分
      const hash = window.location.href.substring(hashIndex + 1);
      // 使用正则表达式匹配参数，包括'?'的存在
      const reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(&|$)", "i");
      const r = hash.match(reg);
      if (r != null) return decodeURIComponent(r[2]); // 如果找到参数，返回解码后的值
    } else {
      // 如果不是hash模式，尝试从search中获取参数
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURIComponent(r[2]); // 如果找到参数，返回解码后的值
    }
    return null; // 如果没有找到参数，返回null
  };
    // 过滤表情包
    Vue.prototype.formateEmoji = function (value) {
      const specialCharsPattern = /[^a-zA-Z0-9\u4e00-\u9fa5]/g
      value = value.replace(specialCharsPattern, '');
      value = value.replace(/(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g, "")
      return value.replace(/(^\s*)|(\s*$)/g, "").trim();
    }
    //根据sessionKey获取用户信息 全局函数
    Vue.prototype.getUserInfo = function (userinfosessionKey, redirect, callback){

      redirect = redirect ? decodeURIComponent(redirect) : undefined;

      _this.axios.post(_this.$store.state.api.common + 'login/get_userinfo_by_token', _this.qs.stringify({
        token: userinfosessionKey
      })).then(function(res){
      // _this.axios.get(_this.$store.state.api.login_api + '/checkLogin', {
      //   params:{sessionKey: userinfosessionKey}
      // }).then(function(res){

        // console.log(res);

        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              _this.$router.replace({ path: '/login', query: { redirect: redirect }});
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){
            const fetch_data = res.data.data;
            //console.log(fetch_data);

            let user_data = {
              sessionkey: fetch_data.token,

              id: fetch_data.id,
              username: fetch_data.username,
              nickname: fetch_data.nickname ? fetch_data.nickname : '无昵称',
              name: fetch_data.realname,
              avatar: fetch_data.avatar,

              service_shopno: fetch_data.service_shopno,//服务门店
              ordering_store: fetch_data.ordering_store,//下单门店

              //sbucode: fetch_data._user.bindSbuCode,
              //dealercode: fetch_data._user.bindDealerCode,
              //shopno: fetch_data._user.bindShopNo,
              //roletype: 1,//经销商

            }

            // if( user_data.shopno ){
            //   user_data.roletype = 0;//门店
            // }

            // fetch_data._auth.forEach(function(item_goods){
            //     if(item_goods.role_code == "master"){
            //       user_data.roletype = 2;//总部
            //     }
            // });
            _this.$store.commit('updateLoginUser', user_data);
            //本地存储
            localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session
            //sessionStorage.setItem('user_','#/IndexA');

            //读取
            //console.log( localStorage.getItem('user_data') );
            //console.log( JSON.parse(localStorage.getItem('user_data')) );

            callback && callback();

            if( redirect ){
              location.replace(redirect);
              if( redirect != './' ){
                //location.reload();
              }
            }

          } else {
            console.error('自动登录失败');
            _this.$router.replace({ path: '/login', query: { redirect: redirect }});
            // _this.$dialog.confirm({
            //   closeOnPopstate: true,//页面回退时自动关闭
            //   title: '登录失效',
            //   message: '出现了一些问题',
            //   showCancelButton: false,
            //   confirmButtonText: '前往opo登录',
            // }).then(() => {
            //   location.replace(_this.$store.state.externalurl.opo);
            // }).catch(() => {
            // });
          }

        } else {
          console.error(res.data.msg ? res.data.msg : '自动登录失败——2');
          _this.$router.replace({ path: '/login', query: { redirect: redirect }});
          // _this.$dialog.confirm({
          //   closeOnPopstate: true,//页面回退时自动关闭
          //   title: '请求用户失败',
          //   message: '出现了一些问题',
          //   showCancelButton: false,
          //   confirmButtonText: '前往opo登录',
          // }).then(() => {
          //   location.replace(_this.$store.state.externalurl.opo);
          // }).catch(() => {
          // });
        }

      }).catch(function (error) {
        _this.$router.replace({ path: '/login', query: { redirect: redirect }});
        // _this.$dialog.confirm({
        //   closeOnPopstate: true,//页面回退时自动关闭
        //   title: '获取用户信息出错',
        //   message: '出现了一些问题',
        //   showCancelButton: false,
        //   confirmButtonText: '前往opo登录',
        // }).then(() => {
        //   location.replace(_this.$store.state.externalurl.opo);
        // }).catch(() => {
        // });
        console.error(error);
      });
    }

    //刷新sessionKey（token） 全局函数
    //callback 成功，sorryFn 失败
    Vue.prototype.refreshToken = async function (callback, sorryFn){


      //如果在App环境中，调用App的刷新Token方法
      if( _this.checkGiantAppVersion('2.3.4', true) ){
        if( _this.$store.state.browser.ios ){
          JSBridge.reload.postMessage("");
        } else {
          android.reload();
        }
        return false;
      }

      // console.log(_this.GLOBAL.pageApiUrl + '/user/checkUserInfo')
      // console.log(userinfosessionKey)

      _this.axios.post(_this.$store.state.api.common + 'login/refresh_token', _this.qs.stringify({
        token: _this.$store.state.loginUser.sessionkey
      })).then(async function (res) {

        // console.log(res);

        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              console.error(error);
              if (sorryFn) {
                if (typeof sorryFn == "function") {
                  sorryFn();
                } else {
                  _this.$dialog.confirm({
                    closeOnPopstate: true,//页面回退时自动关闭
                    title: res.data.msg,
                    message: '您可以尝试：',
                    confirmButtonText: '重新登录',
                    cancelButtonText: '刷新重试'
                  }).then(() => {
                    //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath }});
                    _this.$router.replace({path: '/login', query: {redirect: location.href}});
                  }).catch(() => {
                    location.reload(true);
                  });
                }
              }
              return false;
            }
          }
          if (res.data.status == 1) {
            let user_data = JSON.parse(localStorage.getItem('giant_userdata')) || _this.$store.state.loginUser;
            //const fetch_data = res.data.data;
            //console.log(fetch_data);
            if (typeof callback == "function") {
              // console.log(user_data.sessionkey, res.data.data)
              if (res.data.data && user_data.sessionkey !== res.data.data) {
                window.location.reload()
                // // setTimeout(async () => {
                // await callback()
                // // },Math.ceil(Math.random()*500))
              }
              // const timer = setTimeout(function(){
              //   alert('callback')
              //   callback();
              // }, Math.ceil(Math.random()*500));//增加<500毫秒的延时
              // clearTimeout(timer)
            }
            user_data.sessionkey = res.data.data;
            //本地存储
            localStorage.setItem('giant_userdata', JSON.stringify(user_data));//session
            _this.$store.commit('updateLoginUser', user_data);
          } else if (res.data.status == 3) {//token有误，已无效
            //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath }});
            _this.$router.replace({path: '/login', query: {redirect: location.href}});
            return false;
            //_this.$toast(res.data.msg);
            if (sorryFn) {
              if (typeof sorryFn == "function") {
                sorryFn();
              } else {
                _this.$dialog.confirm({
                  closeOnPopstate: true,//页面回退时自动关闭
                  title: res.data.msg,
                  message: '您可以尝试：',
                  confirmButtonText: '重新登录',
                  cancelButtonText: '返回上一页'
                }).then(() => {
                  //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath }});
                  _this.$router.replace({path: '/login', query: {redirect: location.href}});
                }).catch(() => {
                  history.back();
                });
              }
            }
          } else {
            //_this.$toast('更新令牌出现了一些问题');
            if (sorryFn) {
              if (typeof sorryFn == "function") {
                sorryFn();
              } else {
                _this.$dialog.confirm({
                  closeOnPopstate: true,//页面回退时自动关闭
                  title: res.data.msg ? res.data.msg : '更新令牌出现了一些问题',
                  message: '您可以尝试：',
                  confirmButtonText: '重新登录',
                  cancelButtonText: '返回上一页'
                }).then(() => {
                  //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath }});
                  _this.$router.replace({path: '/login', query: {redirect: location.href}});
                }).catch(() => {
                  history.back();
                });
              }
            }
          }

        } else {
          //_this.$toast('请求更新令牌失败');
          if (sorryFn) {
            if (typeof sorryFn == "function") {
              sorryFn();
            } else {
              _this.$dialog.confirm({
                closeOnPopstate: true,//页面回退时自动关闭
                title: '请求更新令牌失败',
                message: '您可以尝试：',
                confirmButtonText: '重新登录',
                cancelButtonText: '返回上一页'
              }).then(() => {
                //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath }});
                _this.$router.replace({path: '/login', query: {redirect: location.href}});
              }).catch(() => {
                history.back();
              });
            }
          }
        }

      }).catch(function (error) {
        console.error(error);
        if( sorryFn ){
          if( typeof sorryFn == "function" ){
            sorryFn();
          } else {
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '更新令牌出现异常',
              message: '您可以尝试：',
              confirmButtonText: '重新登录',
              cancelButtonText: '返回上一页'
            }).then(() => {
              //_this.$router.replace({ path: '/login', query: { redirect: _this.$route.fullPath }});
              _this.$router.replace({ path: '/login', query: { redirect: location.href }});
            }).catch(() => {
              history.back();
            });
          }
        }
      });
    };
    //拉取并返回购物车内商品数量，全局函数
    Vue.prototype.getCartCount = function (callback){

      if( !_this.$store.state.loginUser.sessionkey ){
        return false;
      }
      let tmpParams = {
        user_id: _this.$store.state.loginUser.sessionkey,//用户token
      }
      _this.axios.post(_this.$store.state.api.common + 'goods/get_cart_goods_count', _this.qs.stringify(
        tmpParams
      )).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){
            let fetch_data = 0;
            if( Number(res.data.data) > 0 ){
              fetch_data = Number(res.data.data);
            }
            _this.$store.commit('changeCartCount', fetch_data);
            if(typeof callback == 'function'){
              callback();
            }
          }else if ( res.data.status == 2 ){
            _this.refreshToken(function(){
              _this.getCartCount(callback);
            });
          } else {
            console.log('获取购物车商品数失败' + (res.data.msg ? '：' + res.data.msg : ''));
          }
        } else {
          console.error('请求购物车商品数失败');
        }
      }).catch(function (error) {
        console.error('请求购物车商品数失败', error);
      });
    };
    //判断骑行App版本是否为 某个固定版本  例如 5.0.0
    Vue.prototype.checkGiantAppEqualVersion = function (limit_giantappversion){
      let matches = window.navigator.userAgent.toLowerCase().match(/_giantapp\/([\d]+)\.([\d]+)\.([\d]+)/);
      let limit_var = limit_giantappversion.split('.');
      if(limit_var[0] == matches[1] && limit_var[1] == matches[2] && limit_var[2] == matches[3]){
        return true
      }
    }
    //判断骑行App版本 atleast 至少
    Vue.prototype.checkGiantAppVersion = function (limit_giantappversion, atleast){
      let matches = window.navigator.userAgent.toLowerCase().match(/_giantapp\/([\d]+)\.([\d]+)\.([\d]+)/);
      if( matches ){
        let limit_var = limit_giantappversion.split('.');
        if( atleast ){
          if( Number(matches[1]) > Number(limit_var[0]) ){
            return true;
          } else if( Number(matches[1]) == Number(limit_var[0]) ){
            if( Number(matches[2]) > Number(limit_var[1]) ){
              return true;
            } else if( Number(matches[2]) == Number(limit_var[1]) ){
              return Number(matches[3]) >= Number(limit_var[2]);
            }
          } else {
            return false;
          }
        } else {
          if( Number(limit_var[0]) > Number(matches[1]) ){
            return true;
          } else if( Number(limit_var[0]) == Number(matches[1]) ){
            if( Number(limit_var[1]) > Number(matches[2]) ){
              return true;
            } else if( Number(limit_var[1]) == Number(matches[2]) ){
              return Number(limit_var[2]) > Number(matches[3]);
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }

    };
    //判断电动车App版本 atleast 至少
    Vue.prototype.checkEVGiantAppVersion = function (limit_giantappversion, atleast){
      // let agent = "Mozilla/5.0 (Linux; Android 10; PACM00 Build/QP1A.190711.020; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/77.0.3865.92 Mobile Safari/537.36; giantevapp/3.1.3"
      let matches = window.navigator.userAgent.toLowerCase().match(/giantevapp\/([\d]+)\.([\d]+)\.([\d]+)/);
      if( matches ){
        let limit_var = limit_giantappversion.split('.');
        if( atleast ){
          if( Number(matches[1]) > Number(limit_var[0]) ){
            return true;
          } else if( Number(matches[1]) == Number(limit_var[0]) ){
            if( Number(matches[2]) > Number(limit_var[1]) ){
              return true;
            } else if( Number(matches[2]) == Number(limit_var[1]) ){
              return Number(matches[3]) >= Number(limit_var[2]);
            }
          } else {
            return false;
          }
        } else {
          if( Number(limit_var[0]) > Number(matches[1]) ){
            return true;
          } else if( Number(limit_var[0]) == Number(matches[1]) ){
            if( Number(limit_var[1]) > Number(matches[2]) ){
              return true;
            } else if( Number(limit_var[1]) == Number(matches[2]) ){
              return Number(limit_var[2]) > Number(matches[3]);
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    };
    //判断电动车App版本 atleast 至少
    Vue.prototype.checkGiantAppVersionE = function (limit_giantappversion, atleast){

      let matches = window.navigator.userAgent.toLowerCase().match(/giantevapp\/([\d]+)\.([\d]+)\.([\d]+)/);
      if( matches ){
        let limit_var = limit_giantappversion.split('.');
        if( atleast ){
          if( Number(matches[1]) > Number(limit_var[0]) ){
            return true;
          } else if( Number(matches[1]) == Number(limit_var[0]) ){
            if( Number(matches[2]) > Number(limit_var[1]) ){
              return true;
            } else if( Number(matches[2]) == Number(limit_var[1]) ){
              return Number(matches[3]) >= Number(limit_var[2]);
            }
          } else {
            return false;
          }
        } else {
          if( Number(limit_var[0]) > Number(matches[1]) ){
            return true;
          } else if( Number(limit_var[0]) == Number(matches[1]) ){
            if( Number(limit_var[1]) > Number(matches[2]) ){
              return true;
            } else if( Number(limit_var[1]) == Number(matches[2]) ){
              return Number(limit_var[2]) > Number(matches[3]);
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }

    };
    //骑行app版本 华为系列手机（荣耀）
    Vue.prototype.noInsure = function (){
      let noInsure = 0
      if(_this.$store.state.browser.giantapp){
          if(_this.$store.state.browser.honor || this.$store.state.browser.huawei){
            if(_this.checkGiantAppVersion('2.17.1',1)){
              noInsure = 1
            }
          }
      }
      return noInsure
    };

    //================ 工具相关

    //返回上一页
    Vue.prototype.backToPrevpage = function () {
      if(_this.$store.state.browser.giantapp && _this.getQueryString('from_giant_app') && _this.checkGiantAppVersion('4.0.0','4.0.0')){
        if(_this.$store.state.browser.ios){
          window.webkit.messageHandlers.closeWebView.postMessage('');
        } else {
          android.closeWebView();
        }
      }else{
        if( history.length > 1 ){
          router.go(-1);
        } else {
          router.push({path: '/'});
        }
      }
    };

    //复制到剪贴板
    Vue.prototype.copyToClipboard = function (content){

      const textString = content.toString();//数字没有 .length 不能执行selectText 需要转化成字符串
      let input = document.querySelector('#copy-input');
      if (!input) {
        input = document.createElement('input');
        input.id = "copy-input";
        input.readOnly = "readOnly";        // 防止ios聚焦触发键盘事件
        input.style.position = "absolute";
        input.style.left = "-1000px";
        input.style.zIndex = "-1000";
        document.body.appendChild(input)
      }

      input.value = textString;
      // ios必须先选中文字且不支持 input.select();
      selectText(input, 0, textString.length);
      console.log(document.execCommand('copy'), 'execCommand');
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        //alert('已复制到粘贴板');
      }
      input.blur();

      // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
      // 选择文本。createTextRange(setSelectionRange)是input方法
      function selectText(textbox, startIndex, stopIndex) {
        if (textbox.createTextRange) {//ie
          const range = textbox.createTextRange();
          range.collapse(true);
          range.moveStart('character', startIndex);//起始光标
          range.moveEnd('character', stopIndex - startIndex);//结束光标
          range.select();//不兼容苹果
        } else {//firefox/chrome
          textbox.setSelectionRange(startIndex, stopIndex);
          textbox.focus();
        }
      }

      /*
      if (window.clipboardData) {
        window.clipboardData.setData('text', content);
      } else {
        (function (content) {
          document.oncopy = function (e) {
            e.clipboardData.setData('text', content);
            e.preventDefault();
            document.oncopy = null;
          }
        })(content);
        document.execCommand('Copy');
      }
      */
    };

    //页面滚动到，全局函数
    //https://stackoverflow.com/questions/21474678/scrolltop-animation-without-jquery
    Vue.prototype.scrollToTop = function (duration = 500, targettop = 100, linear = false){
      // cancel if already on top
      if (document.scrollingElement.scrollTop === targettop) return;
      if( linear ){
        const cosParameter = document.scrollingElement.scrollTop - targettop;
        let scrollY = cosParameter, oldTimestamp = null;
        let firstTimestamp = null;//通过时间戳判断何时终止
        function step (newTimestamp) {
          if ( firstTimestamp === null ){
            firstTimestamp = newTimestamp;
          }
          if (oldTimestamp !== null) {
            scrollY -= cosParameter * (newTimestamp - oldTimestamp) / duration;
            //if (scrollY > -10 && scrollY < 10) return document.scrollingElement.scrollTop = targettop;
            if (oldTimestamp - firstTimestamp >= duration) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop + scrollY;
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      } else {
        const cosParameter = (targettop - document.scrollingElement.scrollTop) / 2;
        let scrollCount = 0, oldTimestamp = null;
        function step (newTimestamp) {
          if (oldTimestamp !== null) {
            // if duration is 0 scrollCount will be Infinity
            scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration;
            if (scrollCount >= Math.PI) return document.scrollingElement.scrollTop = targettop;
            document.scrollingElement.scrollTop = targettop - (cosParameter + cosParameter * Math.cos(scrollCount));
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      }
    };

    //通过经纬度计算距离，返回公里数
    Vue.prototype.calcDistance = function (lat1, lng1, lat2, lng2){
      function Rad(d){
        return d * Math.PI / 180.0;//经纬度转换成三角函数中度分表形式。
      }
      var radLat1 = Rad(lat1);
      var radLat2 = Rad(lat2);
      var a = radLat1 - radLat2;
      var  b = Rad(lng1) - Rad(lng2);
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a/2),2) +
      Math.cos(radLat1)*Math.cos(radLat2)*Math.pow(Math.sin(b/2),2)));
      s = s *6378.137 ;// EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000; //输出为公里
      //s=s.toFixed(4);
      return s;
    };

    //获取用户当前位置（定位）
    Vue.prototype.getUserPostion = function (mustReFresh = false, fnCallback, fnError){
      // 判断是微信或者微信小程序
      if(_this.$store.state.browser.wx || _this.$store.state.browser.wxminiprogram){
        // return false
        let tmpParams = {
          url: location.href,//_this.$store.state.siteUrl,//分享链接URL
          apiname: 'Giant',
          apipwd: 'Dline!@1587',
          wxname: 'giantfwh'
        }
        //对 iOS 特殊处理
        if(_this.$store.state.browser.ios) {
          // if(!sessionStorage.getItem('firsttouch4ios')){//将入口地址保存下来，iOS 分享会使用
          //   sessionStorage.setItem('firsttouch4ios', window.location.href);
          // }
          tmpParams.url = window.location.href.split('#')[0]
            // sessionStorage.getItem('firsttouch4ios');
        }
        _this.axios.post(_this.$store.state.api.wechat_share, _this.qs.stringify(tmpParams)).then(function(res){
          if( res.status == 200 ){
            if( typeof res.data != "object" ){
              res.data = JSON.parse(res.data);
            }
            if( res.data.status == 1 ){
              const fetch_data = res.data.jspack;
              let latitude =  ''
              let longitude = ''
              wx.checkJsApi({
                jsApiList: ['getLocation'],
                success: function (res) {
                  if (res.checkResult.getLocation == false) {
                    alert('你的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！');
                    return;
                  }
                }
              });
              wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: fetch_data.appId,//_this.$store.state.wxAppId
                timestamp: fetch_data.timeStamp ? fetch_data.timeStamp : 1,
                nonceStr: fetch_data.nonceStr ? fetch_data.nonceStr : '',//nonceStr
                signature: fetch_data.signatureStr ? fetch_data.signatureStr : '',
                jsApiList: ['checkJsApi','getLocation'] // 必填，
              });
              wx.ready(function () {
                wx.getLocation({
                  type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                  isHighAccuracy:true,
                  success: function (res) {
                    latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                    longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                    let userpostion_data = {
                      lat: latitude,//高精 //result.position.lat
                      lng: longitude,//高精 //result.position.lng
                    }
                    _this.$store.dispatch('updateUserPosition',{data:userpostion_data })
                    //本地存储
                    localStorage.setItem('giant_userpostion', JSON.stringify(userpostion_data));//session
                    fnCallback && fnCallback(userpostion_data);
                  },
                  fail: function (err) {
                    fnError && fnError(err);
                }
                  })
                });
            } else {
              fnError && fnError('定位失败');
            }
          } else {
            fnError && fnError('定位失败');
          }
        }).catch(function (error) {
          fnError && fnError('定位失败');
        });
      }else if(_this.$store.state.browser.giantapp && _this.checkGiantAppVersion('3.3.0',"3.3.0")){ // 骑行app && _this.checkGiantAppVersion('3.3.0',"3.3.0")  3.3.0    2023/4/24   因为骑行App于2023年4.21日发版
        if(_this.$store.state.browser.ios){
          window.webkit.messageHandlers.requestLocation.postMessage("");
        }else{
          window.android.requestLocation();//请求app定位
        }
        fnCallback && fnCallback();
      }else if(_this.$store.state.browser.giantevapp && _this.checkEVGiantAppVersion('3.1.9',"3.1.9")){ // 电动车App3.1.7改为3.1.8 2023.4.14  电动车App发版更改  3.1.8->3.1.9  电动车App发版   && _this.checkGiantAppVersion('3.1.8',"3.1.8")
        if(_this.$store.state.browser.ios){
          window.webkit.messageHandlers.getUserLocation.postMessage('');
        }else{
          if(_this.checkEVGiantAppVersion('3.2.2',"3.2.2")){// 2024.03.28  电动车 版本3.2.2及以后版本都用android  3.1.9 是增加定位方法的版本用大写Android
            window.android.getUserLocation('');
          }else{
            window.Android.getUserLocation('');
          }
        }
        fnCallback && fnCallback();
      }else{
        if( !mustReFresh ){//非强制刷新
          let tmpUserpostion = JSON.parse(localStorage.getItem('giant_userpostion'));
          if( tmpUserpostion && tmpUserpostion.lat ){
            fnCallback && fnCallback(tmpUserpostion);
          } else {
            _this.getUserPostion( true, fnCallback, fnError );
          }
          return false;
        }

        window.onGaodeLoad = function(){
          _this.getUserPostion( mustReFresh, fnCallback, fnError );
        }
        if( typeof(AMap) =="undefined" ){
          var url = 'https://webapi.amap.com/maps?v=2.0&key=90bc3da9e0445dd5885581a43922d93c&callback=onGaodeLoad';
          var jsapi = document.createElement('script');
          jsapi.charset = 'utf-8';
          jsapi.src = url;
          document.head.appendChild(jsapi);
        } else {
          let map, geolocation;
          map = new AMap.Map(document.createElement('div'), {
            //resizeEnable: true
          });
          map.plugin('AMap.Geolocation', function() {
            geolocation = new AMap.Geolocation({
              enableHighAccuracy: true, //是否使用高精度定位，默认:true
              timeout: 5000, //超过10秒后停止定位，默认：无穷大
            });
            geolocation.getCurrentPosition(function(status, result){
              // _this.$toast('这里是h5的定位  ==='+status+'结果是'+JSON.stringify(result))
              if(status=='complete'){
                let userpostion_data = {
                  lat: result.position.getLat(),//高精 //result.position.lat
                  lng: result.position.getLng(),//高精 //result.position.lng
                }
                //console.log(userpostion_data);
                _this.$store.dispatch('updateUserPosition',{data:userpostion_data })
                //本地存储
                localStorage.setItem('giant_userpostion', JSON.stringify(userpostion_data));//session

                fnCallback && fnCallback(userpostion_data);

              } else {
                fnError && fnError(result);
              }
            });
          });
        }
      }
    };

    //美化价格的显示 num 待美化的价格 fixed 几位小数 round 四舍五入 thousand 千位符
    Vue.prototype.priceSexy = function(num, fixed = 2, round = true, thousand = false){
      if( isNaN(num) ){
        return num;
      }
      if( fixed >= 0 ){
        if(round){
          num = (Number(num)).toFixed(fixed);
        } else {
          num = (Math.floor(num * 100) / 100).toFixed(fixed);
        }
      }
      if( thousand ){
        var numarr = num.split(".");
        if( numarr.length ) {
          num = (numarr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        }
        if( numarr.length > 1 && numarr[1]!="" ) {
          num = "" + num + "." + numarr[1];
        }
      }
      return num;
    };

    //计算 解决js运算bug
    Vue.prototype.mathcalc = function (a, b, mode = '+'){

      if( mode == '-' ){//=========================
        let c, d, e;
        try {
          c = a.toString().split('.')[1].length;
        } catch (f) {
          c = 0;
        }
        try {
          d = b.toString().split('.')[1].length;
        } catch (f) {
          d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (_this.mathcalc(a, e, '*') - _this.mathcalc(b, e, '*')) / e;
      } else if( mode == '*' ){//=========================
        let c = 0,
        d = a.toString(),
        e = b.toString();
        try {
          c += d.split('.')[1].length;
        } catch (f) {}
        try {
          c += e.split('.')[1].length;
        } catch (f) {}
        return Number(d.replace('.', '')) * Number(e.replace('.', '')) / Math.pow(10, c);
      } else if( mode == '/' ){//=========================
        let c, d, e = 0,f = 0;
        try {
          e = a.toString().split('.')[1].length;
        } catch (g) {}
        try {
          f = b.toString().split('.')[1].length;
        } catch (g) {}
        return c = Number(a.toString().replace('.', '')), d = Number(b.toString().replace('.', '')), _this.mathcalc(c / d, Math.pow(10, f - e), '*');
      } else {//=========================
        let c, d, e;
        try {
          c = a.toString().split('.')[1].length;
        } catch (f) {
          c = 0;
        }
        try {
          d = b.toString().split('.')[1].length;
        } catch (f) {
          d = 0;
        }
        return e = Math.pow(10, Math.max(c, d)), (_this.mathcalc(a, e, '*') + _this.mathcalc(b, e, '*')) / e;
      }
    };

    //格式化时间戳
    Vue.prototype.dateformat = function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss'){
      if( dataStr.toString().length < 13 ){
        dataStr *= 1000;
      }
      return moment(dataStr).format(pattern);
    };

    //base64转Blob
    Vue.prototype.dataURItoBlob = function (dataURI) {
      var byteString = atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mimeString });
    };

    //压缩图片
    //width 宽、height 高、quality 质量、longside 长边（优先级高过宽高）、shortside 短边（优先级最高）
    Vue.prototype.compressImage = function (file, callback, config){

      if (file.type == 'image/gif' || file.type == 'image/jpeg' || file.type == 'image/pjpeg' || file.type == 'image/png' || file.type == 'image/x-png') {

        let tmpParams = {
          width: 1000,
          quality: 0.8
        };

        tmpParams = Object.assign(tmpParams, config);

        //通过canvas压缩图片
        var reader = new FileReader();
        reader.readAsDataURL(file.file);
        var img = new Image;
        reader.onload = function (e) {
          //var width = 1080; //图像大小
          //var quality = 0.8; //图像质量
          var canvas = document.createElement("canvas");
          var drawer = canvas.getContext("2d");
          img.src = this.result;
          img.onload = function () {
            canvas.width = img.width;
            canvas.height = img.height;

            if( tmpParams.shortside ){
              if( img.width > img.height ){
                tmpParams.height = tmpParams.shortside;
                tmpParams.width = tmpParams.height * (img.width / img.height);
              } else if( img.height > img.width ){
                tmpParams.width = tmpParams.shortside;
                tmpParams.height = tmpParams.width * (img.height / img.width);
              }
            }else if( tmpParams.longside ){
              tmpParams.width = tmpParams.height = tmpParams.longside;
            }
            if( tmpParams.width && tmpParams.width < img.width ){
              canvas.width = tmpParams.width;
              canvas.height = tmpParams.width * (img.height / img.width);
            }
            if( tmpParams.height && tmpParams.height < canvas.height ){
              canvas.height = tmpParams.height;
              canvas.width = tmpParams.height * (img.width / img.height);
            }
            drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
            let tmpType = 'image/jpeg';
            if( file.file.type == 'image/png' || file.file.type == 'image/x-png' ){
              tmpType = 'image/png';
            }
            file.file = new window.File([_this.dataURItoBlob(canvas.toDataURL(tmpType, tmpParams.quality))], file.file.name, {type: file.file.type});
            callback && callback(file);
          }
        }
      } else {
        callback && callback(file);
      }
    };


    //初始化微信分享
    Vue.prototype.funWxShare = function (shareConfig={}){
      return false

      if(_this.$store.state.browser.wx) {
        let tmpParams = {
          //re_url: location.href,//_this.$store.state.siteUrl,
          url: location.href,//_this.$store.state.siteUrl,//分享链接URL
          apiname: 'Giant',
          apipwd: 'Dline!@1587',
          wxname: 'giantfwh'
        }
        _this.$store.commit('updatesharetmp', tmpParams);

        //对 iOS 特殊处理
        if(_this.$store.state.browser.ios) {
          if(!sessionStorage.getItem('firsttouch4ios')){//将入口地址保存下来，iOS 分享会使用
            sessionStorage.setItem('firsttouch4ios', window.location.href);
          }
          //tmpParams.re_url = sessionStorage.getItem('firsttouch4ios');
          tmpParams.url = sessionStorage.getItem('firsttouch4ios');
        }

        //_this.axios.post(_this.$store.state.api.common + 'api/get_wx_sign', _this.qs.stringify(tmpParams)).then(function(res){
        _this.axios.post(_this.$store.state.api.wechat_share, _this.qs.stringify(tmpParams)).then(function(res){

          if( res.status == 200 ){
            if( typeof res.data != "object" ){
              res.data = JSON.parse(res.data);
            }
            if( res.data.status == 1 ){//
              wx.checkJsApi({
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'updateAppMessageShareData', 'updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                success: function(res) {
                // 以键值对的形式返回，可用的api值true，不可用为false
                // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}

                }
              });
              //const fetch_data = res.data.data;
              const fetch_data = res.data.jspack;
              //console.log(typeof fetch_data.timeStamp)
              _this.$store.commit('updatesharemsg', fetch_data);
              let json_config = {
                debug: false,
                appId: fetch_data.appId,//_this.$store.state.wxAppId
                timestamp: fetch_data.timeStamp ? fetch_data.timeStamp : 1,
                nonceStr: fetch_data.nonceStr ? fetch_data.nonceStr : '',//nonceStr
                //signature: fetch_data.signature ? fetch_data.signature : '',
                signature: fetch_data.signatureStr ? fetch_data.signatureStr : '',
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'updateAppMessageShareData', 'updateTimelineShareData']

              }

              wx.config(json_config);
              console.log(json_config, '====ffff');

              wx.error(function(res) {
              });
              var shareData= {}
              wx.ready(function () {
                var shareData = {
                  title: '捷安特官方商城 | 专业自行车服务',
                  desc: '捷安特官方商城是捷安特公司精心为用户打造的自行车购物及服务平台',
                  link: location.href,
                  imgUrl: _this.$store.state.siteUrl+'/static/img/share_logo.png',
                  //imgUrl: _this.$store.state.externalurl.GIANT_CDN + '/img/share_logo.png',
                  //imgUrl: 'https://giant-images.oss-cn-shanghai.aliyuncs.com/eshop/static/img/share_logo.png',
                  success: function (res) {
                    console.log(res)
                  },
                  cancel: function (res) {
                    console.log(res)
                  }
                };

                shareData = Object.assign(shareData, shareConfig);

                wx.onMenuShareTimeline(shareData);
                wx.onMenuShareAppMessage(shareData);
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
                // wx.scanQRCode({
                //   needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                //   scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                //   success: function (res) {
                //    // var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                //   }
                // });
              });
              console.log(_this.$store.state.siteUrl+'/static/img/share_logo.png')
              _this.$store.commit('updateshareview', shareConfig);
              //alert('SHARE');
            } else if( res.data.status == 0 ){
              _this.$toast(res.data.msg);
            } else {
              _this.$toast('出现了一些问题');
            }

          } else {
            _this.$toast('请求失败');
          }

        }).catch(function (error) {
          //_this.$toast('请求失败，稍后再试！');
          //_this.$toast(error);
          console.log(error);
        });

      }

    };


    //判断字符串中是否有超过2字节的字符（是否有emoji表情）
    Vue.prototype.is32Bit = function (substring) {
      for (var i = 0; i < substring.length; i++) {
        if( substring.codePointAt(i) > 0xFFFF){
          return true;
        }
      }
      return false;
    };

    //判断字符串中多少个字节
    Vue.prototype.stringByteCount = function (substring) {
      if(!arguments.length||!substring) return null;
      if(''==substring) return 0;
      var l=0;
      for(var i=0;i<substring.length;i++){
        if(substring.charCodeAt(i)>255) l+=2;
        else l++;
      }
      return l;
    };



    //================ 业务相关

    //拉取门店数据
    //funCallback 成功回调 funError 出错回调 funConflict 服务门店有冲突 funClosedown 关店
    Vue.prototype.getStoreData = function (shopno, token, funCallback, funError, funConflict, funClosedown){


      //拉取门店信息
      let tmpParams = {
        code: shopno,
        user_id: token,
      };

      _this.axios.post(_this.$store.state.api.common + 'api/store_detail', _this.qs.stringify(tmpParams)).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              _this.$toast('拉取门店数据情况未知：接口异常');
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            let fetch_data = res.data.data;

            if( !shopno && token ){
              //服务门店与暂存登录信息不符，服务门店已在别处修改过
              if( fetch_data.code != _this.$store.state.loginUser.ordering_store ){

                let loginuser_data = JSON.parse(localStorage.getItem('giant_userdata')) || _this.$store.state.loginUser;
                // loginuser_data.service_shopno = fetch_data.code;
                loginuser_data.ordering_store = fetch_data.code;
                localStorage.setItem('giant_userdata', JSON.stringify(loginuser_data));
                _this.$store.commit('updateLoginUser', loginuser_data);

                funConflict && funConflict();//处理冲突
              }
            }

            funCallback && funCallback(fetch_data);

          }else if ( res.data.status == 2 ){
            _this.refreshToken(function(){
              _this.getStoreData(shopno, token, funCallback, funError, funConflict, funClosedown);
            }, function(){
              _this.$router.push({ name: 'Login', query: {'redirect': location.href}});//登录信息失效直接前往登录
            });
          }else if ( res.data.status == 3 ){
            funClosedown && funClosedown( res.data.data ? res.data.data : '' );//【未知门店】
          }else{
            if( funError ){
              funError();
            } else {
              _this.$dialog.confirm({
                closeOnPopstate: true,//页面回退时自动关闭
                title: res.data.msg ? res.data.msg : '出现了一些问题',
                message: '您可以尝试：',
                confirmButtonText: '刷新重试',
                cancelButtonText: '返回首页'
              }).then(() => {
                location.reload(true);
              }).catch(() => {
                _this.$router.replace({ path: '/'});
              });
            }
          }
        }else{
          if( funError ){
            funError();
          } else {
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '门店数据拉取失败',
              message: '您可以尝试：',
              confirmButtonText: '刷新重试',
              cancelButtonText: '返回首页'
            }).then(() => {
              location.reload(true);
            }).catch(() => {
              _this.$router.replace({ path: '/'});
            });
          }
        }
      }).catch(function (error) {
        console.error(error);
        if( error.response ){
          if( error.response.status == 503 ){
            _this.countDown503();
          }
        } else {
          if( funError ){
            funError();
          } else {
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '门店数据拉取失败',
              message: '您可以尝试：',
              confirmButtonText: '刷新重试',
              cancelButtonText: '返回首页'
            }).then(() => {
              location.reload(true);
            }).catch(() => {
              _this.$router.replace({ path: '/'});
            });
          }

        }

      });

    };

    //测门店区域 true 可买 false 不可买
    Vue.prototype.checkSalesArea = function ( salesArea = '', shopno = '' ){
      if( !shopno ){
        shopno = _this.$store.state.loginUser.ordering_store;// service_shopno
      }

      if( !shopno ){
        return false;
      }

      if( salesArea ){
        let tmpSalesArea = [];
        salesArea.split(',').forEach(store_n => {
          if( store_n ){
            tmpSalesArea.push(store_n);
          }
        });
        if( tmpSalesArea.length && tmpSalesArea.indexOf(shopno) == -1 ){
          return false;
        }
      }
      return true;
    };

    //放入购物车
    Vue.prototype.throwToCart = function (outerParams, funCallback, funError){


      let tmpParams = {
        user_id: _this.$store.state.loginUser.sessionkey,
        goods_id: outerParams.goods_id,
        sku: outerParams.sku,
        num: outerParams.num,
        promotion_id: outerParams.promotion_id ? outerParams.promotion_id : '',//促销ID
        promotion_code: outerParams.promotion_code ? outerParams.promotion_code : '',//促销CODE
        group_id: outerParams.group_id ? outerParams.group_id : '',//分组（购物车）
        type: outerParams.type ? outerParams.type : 1,//1追加 2总量
      };
      if(!['',null,undefined,'undefined'].includes(sessionStorage.getItem('source'))){
        tmpParams.scrm_source = sessionStorage.getItem('source')
      }
      if(!['',null,undefined,'undefined'].includes(sessionStorage.getItem('live_code'))){
        tmpParams.livecodeid = sessionStorage.getItem('live_code')
      }
      if(!['',null,undefined,'undefined'].includes(sessionStorage.getItem('unionid'))){
        tmpParams.unionid = sessionStorage.getItem('unionid')
      }
      // yxj 2025.11.26 增加SCRM埋点 来源渠道 来源 路径 下单门店 经纬度
      const lat = _this.$store.state.giant_userpostion ? _this.$store.state.giant_userpostion.lat : localStorage.getItem('giant_userpostion') ? localStorage.getItem('giant_userpostion').lat : ''
      const lng = _this.$store.state.giant_userpostion ? _this.$store.state.giant_userpostion.lng : localStorage.getItem('giant_userpostion') ? localStorage.getItem('giant_userpostion').lng : ''
      const shopno = _this.$store.state.loginUser.ordering_store ? _this.$store.state.loginUser.ordering_store : localStorage.getItem('giant_userdata') ? JSON.parse(localStorage.getItem('giant_userdata')).ordering_store : '' // 客户下单门店
      const { source_client, scrm_origin } = _this.getScrmEnvironment()
      tmpParams.sourceClient = source_client
      tmpParams.scrm_origin = scrm_origin
      tmpParams.shopno = shopno
      tmpParams.user_long = lng
      tmpParams.user_lat = lat
      _this.axios.post(_this.$store.state.api.common + 'goods/add_cart', _this.qs.stringify(tmpParams)).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              _this.$toast('放入购物车失败：接口异常');
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            funCallback && funCallback();
            // 新增SCRM 埋点  yxj
            let fetch_data = res.data.data;
            if(fetch_data.scrm_behavior_ids){
              if(fetch_data.scrm_behavior_ids.length > 0){
                fetch_data.scrm_behavior_ids.map((v,i)=>{
                  let obj = {
                    type:1,
                    scrm_behavior_id:v
                  }
                  _this.setBehaviorPointScrm(obj);
                })
              }
            }
            //行为埋点
            _this.setBehaviorPoint({
              PAGE: 'prt_info',
              action: 'B3',
              title: outerParams.name,
              UserID: _this.$store.state.loginUser ? _this.$store.state.loginUser.id : '',
              PID: tmpParams.goods_id,
              objCode: 1,
            });

          }else if ( res.data.status == 2 ){
            _this.refreshToken(function(){
              _this.throwToCart(tmpParams, funCallback, funError);
            }, true);
          }else{
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: res.data.msg ? res.data.msg : '出现了一些问题',
              message: '您可以尝试：',
              confirmButtonText: '刷新重试',
              cancelButtonText: '返回首页'
            }).then(() => {
              location.reload(true);
            }).catch(() => {
              _this.$router.replace({ path: '/'});
            });
          }
        }else{
          _this.$dialog.confirm({
            closeOnPopstate: true,//页面回退时自动关闭
            title: '置入购物车失败',
            message: '您可以尝试：',
            confirmButtonText: '刷新重试',
            cancelButtonText: '返回首页'
          }).then(() => {
            location.reload(true);
          }).catch(() => {
            _this.$router.replace({ path: '/'});
          });
        }
      }).catch(function (error) {
        console.error(error);
        if( error.response ){
          if( error.response.status == 503 ){
            _this.countDown503();
          }
        } else {
          _this.$dialog.confirm({
            closeOnPopstate: true,//页面回退时自动关闭
            title: '网络不畅，放入购物车失败',
            message: '您可以尝试：',
            confirmButtonText: '刷新重试',
            cancelButtonText: '返回首页'
          }).then(() => {
            location.reload(true);
          }).catch(() => {
            _this.$router.replace({ path: '/'});
          });


        }

      });



    };

    //================ 主题相关

    //获取远程最新主题信息，全局函数
    Vue.prototype.getCurrentTheme = function (callback, always_callback){

      let tmpParams = {
        current_time: ('' + Date.parse(new Date())).slice(0,-3),//当前时间戳
      }
      _this.axios.post(_this.$store.state.api.common + 'goods/index_theme', _this.qs.stringify(
        tmpParams
      )).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){
            const fetch_data_theme = res.data.data;
            const fetch_data_brandlist = res.data.brand_list;
            const fetch_data_globallimitbuy = res.data.ava_stock ? parseInt(res.data.ava_stock) : 2;
            const fetch_data_token = res.data.token;

            //console.log(fetch_data_theme);

            let tmpTheme = {
              id: fetch_data_theme.id,
              title: fetch_data_theme.title,
              keywordsPreset: [],
              headerBgColor: fetch_data_theme.header_bgcolor ? fetch_data_theme.header_bgcolor : '',
              coupon_num: fetch_data_theme.coupon_num ? fetch_data_theme.coupon_num : 0,

              indexTextEnter: fetch_data_theme.index_textenter ? fetch_data_theme.index_textenter : [],
              //indexBanner: fetch_data_theme.index_banner ? fetch_data_theme.index_banner : [],
              indexBanner: _this.forHuaweiBanner(fetch_data_theme.index_banner) ? _this.forHuaweiBanner(fetch_data_theme.index_banner) : [],
              indexIconenter: fetch_data_theme.index_iconenter ? fetch_data_theme.index_iconenter : [],
              indexPoster: fetch_data_theme.index_poster ? fetch_data_theme.index_poster : [],

              //indexBanner_2: fetch_data_theme.index_banner_2 ? fetch_data_theme.index_banner_2 : [],
              indexBanner_2: _this.forHuaweiBanner(fetch_data_theme.index_banner_2) ? _this.forHuaweiBanner(fetch_data_theme.index_banner_2) : [],
              indexIconenter_2: fetch_data_theme.index_iconenter_2 ? fetch_data_theme.index_iconenter_2 : [],
              indexPoster_2: fetch_data_theme.index_poster_2 ? fetch_data_theme.index_poster_2 : [],

              //indexBanner_3: fetch_data_theme.index_banner_3 ? fetch_data_theme.index_banner_3 : [],
              indexBanner_3: _this.forHuaweiBanner(fetch_data_theme.index_banner_3) ? _this.forHuaweiBanner(fetch_data_theme.index_banner_3) : [],
              indexIconenter_3: fetch_data_theme.index_iconenter_3 ? fetch_data_theme.index_iconenter_3 : [],
              indexPoster_3: fetch_data_theme.index_poster_3 ? fetch_data_theme.index_poster_3 : [],

              //indexBanner_4: fetch_data_theme.index_banner_4 ? fetch_data_theme.index_banner_4 : [],
              indexBanner_4: _this.forHuaweiBanner(fetch_data_theme.index_banner_4) ? _this.forHuaweiBanner(fetch_data_theme.index_banner_4) : [],
              indexIconenter_4: fetch_data_theme.index_iconenter_4 ? fetch_data_theme.index_iconenter_4 : [],
              indexPoster_4: fetch_data_theme.index_poster_4 ? fetch_data_theme.index_poster_4 : [],

              //indexBanner_5: fetch_data_theme.index_banner_5 ? fetch_data_theme.index_banner_5 : [],
              indexBanner_5: _this.forHuaweiBanner(fetch_data_theme.index_banner_5) ? _this.forHuaweiBanner(fetch_data_theme.index_banner_5) : [],
              indexIconenter_5: fetch_data_theme.index_iconenter_5 ? fetch_data_theme.index_iconenter_5 : [],
              indexPoster_5: fetch_data_theme.index_poster_5 ? fetch_data_theme.index_poster_5 : [],

              token: fetch_data_token,//验证更新用的token
            };



            //渐变背景色
            if( fetch_data_theme.header_bgsrc ){
              if( fetch_data_theme.header_bgsrc.type == 1 ){//背景图
                tmpTheme.headerBgSrc = fetch_data_theme.header_bgsrc.background_img;
              } else if( fetch_data_theme.header_bgsrc.type == 2 ){//背景图
                tmpTheme.headerBgSrc = 'linear-gradient('+ fetch_data_theme.header_bgsrc.background_color.thmem_color_deg +'deg, '+ fetch_data_theme.header_bgsrc.background_color.thmem_color_first +', '+ fetch_data_theme.header_bgsrc.background_color.thmem_color_last +')';
              }
            }

            //推广关键词
            if( fetch_data_theme.keywords_preset ){
              tmpTheme.keywordsPreset = fetch_data_theme.keywords_preset.split(",");
            }

            //本地缓存皮肤数据
            localStorage.setItem('giant_themedata', JSON.stringify(tmpTheme));
            localStorage.setItem('giant_brandlist', JSON.stringify(fetch_data_brandlist));
            localStorage.setItem('giant_globallimitbuy', fetch_data_globallimitbuy);

            //全局存下
            _this.$store.commit('updateTheme', tmpTheme);
            _this.$store.commit('updateBrandList', fetch_data_brandlist);
            _this.$store.commit('updateGlobalLimitBuy', fetch_data_globallimitbuy);

            always_callback && always_callback();

            if(typeof(callback) == 'function'){
              callback();
            }
          } else if( res.data.status == 3 ){
            localStorage.removeItem('giant_themedata');
            _this.$store.commit('updateTheme', {});
            console.log('没有设置主题');
          } else {
            console.log(res.data.msg ? res.data.msg : '获取当前主题皮肤失败');
          }
        } else {
          console.error('获取当前主题皮肤出现问题');
        }
      }).catch(function (error) {
        console.error('获取当前主题皮肤失败', error);
      });
    };
    //筛选华为手机banner
    Vue.prototype.forHuaweiBanner = function(indexBanner){
      let arr = []
      indexBanner.forEach(n=>{
        if(!_this.noInsure()){
          arr.push({
            huawei:n.huawei,
            img_url:n.img_url,
            skip_url:n.skip_url,
            open_type: n.open_type
          })
        } else {
          if(n.huawei == '1'){
            arr.push({
              huawei:n.huawei,
              img_url:n.img_url,
              skip_url:n.skip_url,
              open_type: n.open_type
            })
          }
        }
      })
      return arr
    }

    //载入可用的主题皮肤
    Vue.prototype.loadCurrentTheme = function (check, callback, always_callback){

      //localStorage.setItem('giant_themedata', JSON.stringify(loginuser_data));
      //_this.$store.commit('updateTheme', tmpTheme);
      let tmpTheme = localStorage.getItem('giant_themedata');
      if( tmpTheme ){
        tmpTheme = JSON.parse(tmpTheme);
        _this.$store.commit('updateTheme', tmpTheme);//应用本地存储的主题
        if( check ){
          if( tmpTheme.token ){
            _this.checkCurrentTheme(tmpTheme.token, callback, always_callback);//远程判断
          } else {
            _this.getCurrentTheme(callback, always_callback);//获取远程最新主题信息
          }
        } else {
          always_callback && always_callback();
          callback && callback();
        }
      } else {
        if( check ){
          _this.getCurrentTheme(callback, always_callback);//获取远程最新主题信息
        } else {
          always_callback && always_callback();
          callback && callback();
        }
      }
    };

    //远程根据主题皮肤Token判断是否需要载入新的主题皮肤，全局函数
    Vue.prototype.checkCurrentTheme = function (token, callback, always_callback){


      let tmpParams = {
        token: token,//主题信息md5
        timestamp: new Date().getTime()
      }
      _this.axios.post(_this.$store.state.api.common + 'goods/is_update_theme', _this.qs.stringify(
        tmpParams
      )).then(function(res){
        if( res.status == 200 ){
          if( typeof res.data != "object" ){
            try{
              res.data = JSON.parse(res.data);
            } catch(error) {
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 0 ){//更新

            _this.getCurrentTheme(callback, always_callback);//获取远程最新主题信息

          } else if( res.data.status == 1 ){//不更新
            //console.log('判断主题是否过期失败' + res.data.msg);
            always_callback && always_callback();
            callback && callback();

          } else {
            console.log('判断主题是否过期失败');
            always_callback && always_callback();
            callback && callback();
          }
        } else {
          console.error('判断主题是否过期出现问题');
          always_callback && always_callback();
          callback && callback();
        }
      }).catch(function (error) {
        console.error('判断主题是否过期失败', error);
        always_callback && always_callback();
        callback && callback();
      });
    };

    //载入品牌数组
    Vue.prototype.loadBrandList = function (check, callback){
      //品牌
      let tmpBrandList = localStorage.getItem('giant_brandlist');
      if( tmpBrandList ){
        tmpBrandList = JSON.parse(tmpBrandList);
        _this.$store.commit('updateBrandList', tmpBrandList);//应用本地存储的品牌数组
        callback && callback();
      } else {
        _this.getCurrentTheme(callback);//获取远程最新主题信息
      }
    };

    //载入全场单个商品的限购数量
    Vue.prototype.loadGlobalLimitBuy = function (check, callback){
      //品牌
      let tmpGlobalLimitBuy = localStorage.getItem('giant_globallimitbuy');
      if( tmpGlobalLimitBuy ){
        tmpGlobalLimitBuy = tmpGlobalLimitBuy ? parseInt(tmpGlobalLimitBuy) : 2;
        _this.$store.commit('updateGlobalLimitBuy', tmpGlobalLimitBuy);//应用
        callback && callback();
      } else {
        _this.getCurrentTheme(callback);//获取远程最新主题信息
      }
    };
    // 获取网页地址参数
    Vue.prototype.getQueryString = function (name){
      if(this.$route.query[name]){
        return true
      }else {
        return false
      }
    }


    //行为埋点
    Vue.prototype.setBehaviorPoint = function (json){


      //return false;//埋点先关掉

      let tmpParams = {
        SYS: 'SHOP',//平台code
        PAGE: '',//PAGE 来源对照表https://docs.qq.com/sheet/DSUZHWEJBWFhqSHN1?tab=BB08J2
        PID: '',//如果是商品传商品id
        title: document.title,
        action: '',//A1 页访
        VAL: 1,
        info: document.title ? document.title : '官方商城',
        UserID: '',
        shopno: '',
        objCode: 0,//0 无  1商品  2活动 3新闻
        sourceClient: 'other',//客户端来源
        deviceId: '{"unionid": "'+localStorage.getItem('unionid')+'","android-udid": "","ios-udid": "","android-deviceId": "","ios-Keychain": "","ios-IDFA": ""}',
      }
      if(_this.$store.state.browser.wxminiprogram){
        tmpParams.sourceClient = 'mini_program';
      } else if(_this.$store.state.browser.wx){
        tmpParams.sourceClient = 'wechat';
      } else  if(_this.$store.state.browser.giantapp){
        tmpParams.sourceClient = 'giant_app';
      } else if(_this.$store.state.browser.giantevapp){
        tmpParams.sourceClient = 'ev_app';
      } else if(_this.$store.state.browser.m){
        tmpParams.sourceClient = 'mobile';
      } else if(_this.$store.state.browser.b){
        tmpParams.sourceClient = 'pc';
      } else  {
        tmpParams.sourceClient = 'other';
      }

      tmpParams = Object.assign(tmpParams, json);
      //_this.$toast(tmpParams.sourceClient)

      _this.axios.post(_this.$store.state.api.common + 'behavior/send_behavior_json', _this.qs.stringify(
        tmpParams
      )).then(function(res){
      }).catch(function (error) {
      });
    };
    // SCRM埋点渠道 来源 路径判断方法
    Vue.prototype.getScrmEnvironment = function(){
      let source_client = sessionStorage.getItem('source_client') || '' // 来源渠道 链接上的参数
      let scrm_origin = sessionStorage.getItem('scrm_origin') || '' // 来源 链接上的参数
      let scrm_path = sessionStorage.getItem('scrm_path') || '' // 来源路径 链接上的参数
      if (!source_client || source_client == '') {
        if (this.$store.state.browser.wxminiprogram) { // 微信小程序
          source_client = 'WECHAT-MINI'
        } else if (this.$store.state.browser.wx) { // 微信
          source_client = 'WECHAT'
        } else if (this.$store.state.browser.giantapp) { // 骑行App
          source_client = 'APP-BIKE'
        } else if (this.$store.state.browser.comwx) { // 企业微信
          source_client = 'WECHAT-WORK'
        } else {
          source_client = 'WEB'
        }
      }
      return {
        source_client: source_client ? source_client.toUpperCase() : '',
        scrm_origin: scrm_origin,
        scrm_path: scrm_path,
      }
    }
    //SCRM 行为埋点
    Vue.prototype.setBehaviorPointScrm = function (json){
      const userId = this.$store.state.loginUser.id || (localStorage.getItem('giant_userdata') ? JSON.parse(localStorage.getItem('giant_userdata')).id : '')
      const { source_client, scrm_origin, scrm_path } = this.getScrmEnvironment()
      let tmpParams = {}
      const lat = _this.$store.state.giant_userpostion ? _this.$store.state.giant_userpostion.lat : localStorage.getItem('giant_userpostion') ? localStorage.getItem('giant_userpostion').lat : ''
      const lng = _this.$store.state.giant_userpostion ? _this.$store.state.giant_userpostion.lng : localStorage.getItem('giant_userpostion') ? localStorage.getItem('giant_userpostion').lng : ''
      const shopno = _this.$store.state.loginUser.ordering_store ? _this.$store.state.loginUser.ordering_store : localStorage.getItem('giant_userdata') ? JSON.parse(localStorage.getItem('giant_userdata')).ordering_store : '' // 客户下单门店
      let qr_type = ''
      let qr_obj_id = ''
      let qr_staff_id = ''
      let qr_shopno = ''
      if (!['', null, undefined, 'undefined'].includes(sessionStorage.getItem('qr_type'))) {
        qr_type = sessionStorage.getItem('qr_type')
      }
      if (!['', null, undefined, 'undefined'].includes(sessionStorage.getItem('qr_obj_id'))) {
        qr_obj_id = sessionStorage.getItem('qr_obj_id')
      }
      if (!['', null, undefined, 'undefined'].includes(sessionStorage.getItem('qr_staff_id'))) {
        qr_staff_id = sessionStorage.getItem('qr_staff_id')
      }
      if (!['', null, undefined, 'undefined'].includes(sessionStorage.getItem('qr_shopno'))) {
        qr_shopno = sessionStorage.getItem('qr_shopno')
      }
      if(userId && userId != ''){
        tmpParams = {
          sourceClient: source_client,
          scrm_origin: scrm_origin,
          scrm_path: scrm_path, // 来源路径 链接上的参数
          sys: 'SHOP',//平台code
          uid: userId,
          action: json.action,
          title: json.title,
          ts: this.dealTime(new Date().getTime()),
          items: json.items
        }
        if(sessionStorage.getItem('source') && sessionStorage.getItem('source') != ''){
          tmpParams.source = sessionStorage.getItem('source');
        }
        if(json.items && json.items.length){
          json.items.map((v,i)=>{
            if(sessionStorage.getItem('unionid') != undefined && sessionStorage.getItem('unionid') != 'undefined' && sessionStorage.getItem('unionid') && _this.$store.state.browser.wx && sessionStorage.getItem('is_snapshotuser') != 1){
              v.unionid = sessionStorage.getItem('unionid')
            }
            if(sessionStorage.getItem('live_code') && sessionStorage.getItem('live_code') != ''){
               v.livecodeid = sessionStorage.getItem('live_code')
              }
          })
        }
      }else{
        if(_this.$store.state.browser.wx){
          tmpParams = {
            sourceClient: source_client,
            scrm_origin: scrm_origin,
            scrm_path: scrm_path, // 来源路径 链接上的参数
            sys: 'SHOP',//平台code
            action: json.action,
            title: json.title,
            ts: this.dealTime(new Date().getTime()),
            items: json.items
          }
          if(sessionStorage.getItem('source') && sessionStorage.getItem('source') != ''){
            tmpParams.source = sessionStorage.getItem('source')
          }
          if(json.items && json.items.length){
            json.items.map((v,i)=>{
              if(sessionStorage.getItem('unionid') != undefined && sessionStorage.getItem('unionid') != 'undefined' && sessionStorage.getItem('unionid') && _this.$store.state.browser.wx && sessionStorage.getItem('is_snapshotuser') != 1){
                v.unionid = sessionStorage.getItem('unionid')
              }
              if(sessionStorage.getItem('live_code') && sessionStorage.getItem('live_code') != ''){
               v.livecodeid = sessionStorage.getItem('live_code')
              }
            })
          }
        }
      }
      if (json.action == 'S66') {
        tmpParams.shopno = shopno
        tmpParams.user_long = lng
        tmpParams.user_lat = lat
        tmpParams.items = [{ ...json.items[0], qr_type: qr_type, qr_obj_id: qr_obj_id, staff_id: qr_staff_id, shop_no: qr_shopno}]
      }
      _this.axios.post(_this.$store.state.api.common + 'behavior/send_scrm_behavior_json', _this.qs.stringify(json.type == 2 ? {behavior_value: JSON.stringify(tmpParams),type:2} : json)).then(function(res){}).catch(function (error) {});
    };
    // 处理时间
    Vue.prototype.dealTime = function(time){
      var date = new Date(time);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear(),
        M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1),
        D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()),
        h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()),
        m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()),
        s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
      return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s
    }

    //行为埋点后增加需求
    Vue.prototype.setBehaviorPointT = function (json){
      //return false;//埋点先关掉
      let tmpParams = {
        SYS: 'SHOP',//平台code
        PAGE: '',//PAGE 来源对照表https://docs.qq.com/sheet/DSUZHWEJBWFhqSHN1?tab=BB08J2
        PID: '',//如果是商品传商品id
        title: document.title,
        action: '',//A1 页访
        VAL: 1,
        info: document.title ? document.title : '官方商城',
        UserID: '',
        shopno: '',
        objCode: 0,//0 无  1商品  2活动 3新闻
        sourceClient: 'other',//客户端来源
        deviceId: '{"unionid": "'+localStorage.getItem('unionid')+'","android-udid": "","ios-udid": "","android-deviceId": "","ios-Keychain": "","ios-IDFA": ""}',
      }
      tmpParams = Object.assign(tmpParams, json);
      if(tmpParams.PAGE === 'shop_index'){
        if(json.sourceClient && json.sourceClient !== ''){
          tmpParams.sourceClient = json.sourceClient
        }else if(_this.$store.state.browser.wxminiprogram){
          tmpParams.sourceClient = 'mini_program';
        } else if(_this.$store.state.browser.wx){
          tmpParams.sourceClient = 'wechat';
        } else  if(_this.$store.state.browser.giantapp){
          tmpParams.sourceClient = 'giant_app';
        } else if(_this.$store.state.browser.giantevapp){
          tmpParams.sourceClient = 'ev_app';
        } else if(_this.$store.state.browser.m){
          tmpParams.sourceClient = 'mobile';
        } else if(_this.$store.state.browser.b){
          tmpParams.sourceClient = 'pc';
        }
      }else if(tmpParams.PAGE === 'shop_prt_info'){
        if(json.sourceClient && json.sourceClient !== '') {
         if(json.sourceClient === 'qr' || json.sourceClient === 'find'){
           tmpParams.sourceClient = json.sourceClient;
         }
        }else if(_this.$store.state.browser.wxminiprogram){
          tmpParams.sourceClient = 'mini_program';
        } else if(_this.$store.state.browser.wx){
          tmpParams.sourceClient = 'wechat';
        } else  if(_this.$store.state.browser.giantapp){ // 详情增加骑行app环境判断
          tmpParams.sourceClient = 'giant_app';
        }  else if(_this.$store.state.browser.giantevapp){
          tmpParams.sourceClient = 'ev_app';
        } else if(_this.$store.state.browser.m){
          tmpParams.sourceClient = 'mobile';
        } else if(_this.$store.state.browser.b){
          tmpParams.sourceClient = 'pc';
        }
      }
      // console.log(tmpParams, '====tttt')
      //_this.$toast(tmpParams.sourceClient)

      _this.axios.post(_this.$store.state.api.common + 'behavior/send_behavior_json', _this.qs.stringify(
        tmpParams
      )).then(function(res){
        sessionStorage.setItem('isOpen', true)
      }).catch(function (error) {
      });
    };

    //503倒计时刷新
    Vue.prototype.countDown503 = function (time){
       let second;
        if(time){
          second = time;
        } else {
          second = 5;
        }

        const toast = _this.$toast.loading({
          duration: 0, // 持续展示 toast
          overlay:true,
          forbidClick: true,
          closeOnClickOverlay: false,
          message: _this.$store.state.Tips503 +'\n'+second+'S',
        });
        const timer = setInterval(() => {
          second--;
          if (second) {
            toast.message = _this.$store.state.Tips503+ '\n' +`${second}S`;
          } else {
            clearInterval(timer);
            // 手动清除 Toast
            toast.clear();

            _this.$dialog.confirm({
              title: '请点击刷新',
              message: '',
              confirmButtonText: '刷新重试',
              cancelButtonText: '',
              showCancelButton: false
            }).then(() => {
              location.reload(true);
            }).catch(() => {

            });
          }
        }, 1000);
    }



    /********************
    http://www.oschina.net/code/snippet_260395_39205

    //WGS-84 to GCJ-02
    GPS.gcj_encrypt(纬,经);

    //GCJ-02 to BD-09
    GPS.bd_encrypt(纬,经);

    //求距离
    GPS.distance(a纬,a经,b纬,b经);

    ********************/
   Vue.prototype.GPS = {
    PI : 3.14159265358979324,
    x_pi : 3.14159265358979324 * 3000.0 / 180.0,
    delta : function (lat, lon) {
        // Krasovsky 1940
        //
        // a = 6378245.0, 1/f = 298.3
        // b = a * (1 - f)
        // ee = (a^2 - b^2) / a^2;
        var a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
        var ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
        var dLat = this.transformLat(lon - 105.0, lat - 35.0);
        var dLon = this.transformLon(lon - 105.0, lat - 35.0);
        var radLat = lat / 180.0 * this.PI;
        var magic = Math.sin(radLat);
        magic = 1 - ee * magic * magic;
        var sqrtMagic = Math.sqrt(magic);
        dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * this.PI);
        dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * this.PI);
        return {'lat': dLat, 'lon': dLon};
    },

    //WGS-84 to GCJ-02
    gcj_encrypt : function (wgsLat, wgsLon) {
        if (this.outOfChina(wgsLat, wgsLon))
            return {'lat': wgsLat, 'lon': wgsLon};

        var d = this.delta(wgsLat, wgsLon);
        return {'lat' : wgsLat + d.lat,'lon' : wgsLon + d.lon};
    },
    //GCJ-02 to WGS-84
    gcj_decrypt : function (gcjLat, gcjLon) {
        if (this.outOfChina(gcjLat, gcjLon))
            return {'lat': gcjLat, 'lon': gcjLon};

        var d = this.delta(gcjLat, gcjLon);
        return {'lat': gcjLat - d.lat, 'lon': gcjLon - d.lon};
    },
    //GCJ-02 to WGS-84 exactly
    gcj_decrypt_exact : function (gcjLat, gcjLon) {
        var initDelta = 0.01;
        var threshold = 0.000000001;
        var dLat = initDelta, dLon = initDelta;
        var mLat = gcjLat - dLat, mLon = gcjLon - dLon;
        var pLat = gcjLat + dLat, pLon = gcjLon + dLon;
        var wgsLat, wgsLon, i = 0;
        while (1) {
            wgsLat = (mLat + pLat) / 2;
            wgsLon = (mLon + pLon) / 2;
            var tmp = this.gcj_encrypt(wgsLat, wgsLon)
            dLat = tmp.lat - gcjLat;
            dLon = tmp.lon - gcjLon;
            if ((Math.abs(dLat) < threshold) && (Math.abs(dLon) < threshold))
                break;

            if (dLat > 0) pLat = wgsLat; else mLat = wgsLat;
            if (dLon > 0) pLon = wgsLon; else mLon = wgsLon;

            if (++i > 10000) break;
        }
        //console.log(i);
        return {'lat': wgsLat, 'lon': wgsLon};
    },
    //GCJ-02 to BD-09
    bd_encrypt : function (gcjLat, gcjLon) {
        var x = gcjLon, y = gcjLat;
        var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * this.x_pi);
        var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * this.x_pi);
        var bdLon = z * Math.cos(theta) + 0.0065;
        var bdLat = z * Math.sin(theta) + 0.006;
        return {'lat' : bdLat,'lon' : bdLon};
    },
    //BD-09 to GCJ-02
    bd_decrypt : function (bdLat, bdLon) {
        var x = bdLon - 0.0065, y = bdLat - 0.006;
        var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * this.x_pi);
        var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * this.x_pi);
        var gcjLon = z * Math.cos(theta);
        var gcjLat = z * Math.sin(theta);
        return {'lat' : gcjLat, 'lon' : gcjLon};
    },
    //WGS-84 to Web mercator
    //mercatorLat -> y mercatorLon -> x
    mercator_encrypt : function(wgsLat, wgsLon) {
        var x = wgsLon * 20037508.34 / 180.;
        var y = Math.log(Math.tan((90. + wgsLat) * this.PI / 360.)) / (this.PI / 180.);
        y = y * 20037508.34 / 180.;
        return {'lat' : y, 'lon' : x};
        /*
        if ((Math.abs(wgsLon) > 180 || Math.abs(wgsLat) > 90))
            return null;
        var x = 6378137.0 * wgsLon * 0.017453292519943295;
        var a = wgsLat * 0.017453292519943295;
        var y = 3189068.5 * Math.log((1.0 + Math.sin(a)) / (1.0 - Math.sin(a)));
        return {'lat' : y, 'lon' : x};
        //*/
    },
    // Web mercator to WGS-84
    // mercatorLat -> y mercatorLon -> x
    mercator_decrypt : function(mercatorLat, mercatorLon) {
        var x = mercatorLon / 20037508.34 * 180.;
        var y = mercatorLat / 20037508.34 * 180.;
        y = 180 / this.PI * (2 * Math.atan(Math.exp(y * this.PI / 180.)) - this.PI / 2);
        return {'lat' : y, 'lon' : x};
        /*
        if (Math.abs(mercatorLon) < 180 && Math.abs(mercatorLat) < 90)
            return null;
        if ((Math.abs(mercatorLon) > 20037508.3427892) || (Math.abs(mercatorLat) > 20037508.3427892))
            return null;
        var a = mercatorLon / 6378137.0 * 57.295779513082323;
        var x = a - (Math.floor(((a + 180.0) / 360.0)) * 360.0);
        var y = (1.5707963267948966 - (2.0 * Math.atan(Math.exp((-1.0 * mercatorLat) / 6378137.0)))) * 57.295779513082323;
        return {'lat' : y, 'lon' : x};
        //*/
    },
    // two point's distance
    distance : function (latA, lonA, latB, lonB) {
        var earthR = 6371000.;
        var x = Math.cos(latA * this.PI / 180.) * Math.cos(latB * this.PI / 180.) * Math.cos((lonA - lonB) * this.PI / 180);
        var y = Math.sin(latA * this.PI / 180.) * Math.sin(latB * this.PI / 180.);
        var s = x + y;
        if (s > 1) s = 1;
        if (s < -1) s = -1;
        var alpha = Math.acos(s);
        var distance = alpha * earthR;
        return distance;
    },
    outOfChina : function (lat, lon) {
        if (lon < 72.004 || lon > 137.8347)
            return true;
        if (lat < 0.8293 || lat > 55.8271)
            return true;
        return false;
    },
    transformLat : function (x, y) {
        var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
        ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
        ret += (20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin(y / 3.0 * this.PI)) * 2.0 / 3.0;
        ret += (160.0 * Math.sin(y / 12.0 * this.PI) + 320 * Math.sin(y * this.PI / 30.0)) * 2.0 / 3.0;
        return ret;
    },
    transformLon : function (x, y) {
        var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
        ret += (20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0 / 3.0;
        ret += (20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin(x / 3.0 * this.PI)) * 2.0 / 3.0;
        ret += (150.0 * Math.sin(x / 12.0 * this.PI) + 300.0 * Math.sin(x / 30.0 * this.PI)) * 2.0 / 3.0;
        return ret;
    }
  };



  }
}







// WEBPACK FOOTER //
// ./src/assets/js/site.js